<ssp-header></ssp-header>
<div class='page-container'><router-outlet></router-outlet></div>
